import { Form } from '@components/Form/Form';
import { IFormItem } from '@components/Form/FormItem/FormItem';
import { Card as AntdCard, Typography } from 'antd';
import React, { Fragment } from 'react';

import cl from './styles.module.scss';

const { Title } = Typography;
export interface IFilterProps {
  open: boolean;
  filters?: Record<string, any>;
  schema: IFormItem[];
  loading?: boolean;
  onSubmit: (values: any) => void;
  onReset?: () => void;
}

export const Filter: React.FC<IFilterProps> = ({
  open,
  schema,
  filters,
  onSubmit,
  onReset,
  loading = false,
}) => {
  const handleSubmit = (values: Record<string, any>) => {
    onSubmit({ ...values });
  };

  const handleReset = () => {
    onReset?.();
  };

  return open ? (
    <AntdCard className={cl.filter} loading={loading}>
      <Title level={4}>Фильтр</Title>
      <Form
        data={filters}
        schema={schema}
        layout={{
          formLayout: 'horizontal',
          itemLayout: 'vertical',
        }}
        onSubmit={handleSubmit}
        onCancel={handleReset}
        buttons={{
          submit: {
            text: 'Применить',
          },
          cancel: {
            text: 'Сбросить',
          },
        }}
      />
    </AntdCard>
  ) : (
    <Fragment />
  );
};
